import { render, staticRenderFns } from "./ApprovedHistory.vue?vue&type=template&id=eb31451a&scoped=true&"
import script from "./ApprovedHistory.vue?vue&type=script&lang=js&"
export * from "./ApprovedHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb31451a",
  null
  
)

export default component.exports